import { createSlice } from "@reduxjs/toolkit";
import editHospitalTeleModPrice from "../../../rtk-apis/hospital/editHospitalTeleCredit";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const editHospitalTeleModPriceSlice = createSlice({
    name: "editHospitalTeleModPriceSlice",
    initialState,
    reducers: {
        clearHospitalEditTeleModPriceState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(editHospitalTeleModPrice.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(editHospitalTeleModPrice.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload.data;
                state.msg = payload.msg;
            })
            .addCase(editHospitalTeleModPrice.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
                state.status = 'ERROR'
            });
    },
});

export default editHospitalTeleModPriceSlice.reducer;
export const { clearHospitalEditTeleModPriceState } = editHospitalTeleModPriceSlice.actions;
